var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.189 15.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,15.831v2.982H7.482l8.8-8.8L13.3,7.035Zm14.084-8.12a.792.792,0,0,0,0-1.121L16.723,4.729a.792.792,0,0,0-1.121,0L14.146,6.184l2.982,2.982,1.455-1.455Z",
    transform: "translate(0.372 -4.496)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 16.705,
    transform: "translate(0 14.617)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1b5920c77f2a7f771d17b6a0ea1e2bcc.svg";
export { ForwardRef as ReactComponent };